import without from 'lodash/without';

import { APPLY_PRESET, SET_FILTERS } from '@gogame/screens';

import { mapPresetToState } from './schemas';

export const SET_WIDGETS = 'SET_WIDGETS';
export const DELETE_WIDGET = 'DELETE_WIDGET';
export const COLLAPSE_WIDGET = 'COLLAPSE_WIDGET';

export default function homeDashboardReducer(state = {}, action) {
  switch (action.type) {
    case SET_FILTERS:
      const { payload } = action;
      const nextPresets = payload.presets || []; // form trims on submitting all empty values
      const prevPresets = state.filters.presets || [];
      const addedPresets = without(nextPresets, ...prevPresets);
      const widgets = [
        ...state.widgets
          .map(row => {
            return row.filter(({ id }) => nextPresets.includes(id));
          })
          .filter(row => row.length > 0),
        ...addedPresets.map(id => [{ id }]), // each new widget in separate row
      ];

      return {
        ...state,
        filters: payload,
        widgets: widgets,
      };

    case SET_WIDGETS:
      return {
        ...state,
        widgets: action.payload,
      };

    case COLLAPSE_WIDGET:
      return {
        ...state,
        widgets: state.widgets.map(row =>
          row.map(widget => {
            if (widget.id === action.id) {
              return {
                ...widget,
                collapsed: action.payload,
              };
            }
            return widget;
          })
        ),
      };

    case DELETE_WIDGET:
      return {
        ...state,
        filters: {
          ...state.filters,
          presets: state.filters.presets.filter(id => id !== action.payload),
        },
        widgets: state.widgets
          .map(row => row.filter(({ id }) => id !== action.payload))
          .filter(row => row.length),
      };

    case APPLY_PRESET:
      if (action.payload) {
        const { id, data } = action.payload;
        const { applyPresetData } = action.meta;

        // if applyPresetData is 'false', it is new preset and it's data equal to current state
        return {
          ...(applyPresetData ? mapPresetToState(data) : state),
          ready: true,
          presetId: id,
        };
      }
      // Active preset was removed
      return {
        ...state,
        // clean activePresetId
        presetId: undefined,
      };

    default:
      return state;
  }
}
